import { Reset } from "@bluframe/blublocks"
import styled from "styled-components"
import colors from "styles/colors"

export const Wrapper = styled.div`
  display: grid;
  row-gap: 12px;
`

export const DependencyList = styled(Reset.Ul)`
  display: grid;
  row-gap: 8px;
`

export const DependencyItem = styled.li`
  border: 1px solid ${colors.iron};
  border-radius: 6px;
  display: grid;
  padding: 10px 12px;
  row-gap: 2px;
`

export const DependencyType = styled.span`
  color: ${colors.osloGray};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`

export const DependencyTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
`

export const DependencyMeta = styled.span`
  color: ${colors.gray};
  font-size: 12px;
`
